import { useGetEconomicMetricsQuery } from 'store/services/economic/economicApi';

export interface TransactionFeeRate {
  /** The live fee rate in percent, as the admin control set it. Undefined until loaded. */
  ratePct: number | undefined;
  /** Elite's discount off that fee, in percent (100 today). Undefined until loaded. */
  eliteDiscountPct: number | undefined;
  isLoading: boolean;
  isError: boolean;
}

/**
 * The one source for every fee display: the public /economic/metrics read,
 * which carries the rate the admin control writes. It never supplies a
 * default, so no surface can flash a stale "1%" while the rate loads; callers
 * render a sentence without the number (or the policy-range sentence) instead.
 */
export const useTransactionFeeRate = (): TransactionFeeRate => {
  const { data, isLoading, isError } = useGetEconomicMetricsQuery();
  return {
    ratePct: data?.transactionFeePercentage,
    eliteDiscountPct: data?.eliteFeeDiscountPercent,
    isLoading,
    isError,
  };
};

export default useTransactionFeeRate;
